import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=baa88366&scoped=true&"
import script from "./Achievements.vue?vue&type=script&lang=js&"
export * from "./Achievements.vue?vue&type=script&lang=js&"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=baa88366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa88366",
  null
  
)

export default component.exports